/**
 * The controller a decoder row belongs to.
 *
 * SCRUM-1032 round 7 review: on a control hub the decoder list's `interfaceId`
 * is the hub that was asked, not the controller the decoder hangs off — that
 * one is `twiOriginalId`. Grouping by `interfaceId` put every hub decoder under
 * a controller id that no group has, so each controller showed 0 decoders and
 * Apply had nothing to run on. On a plain controller the two are the same.
 */
export const decoderOwnerId = (row: any, fallback: number): number =>
  Number(row?.twiOriginalId ?? row?.interfaceId) || fallback
